namespace TabAurous {
    export interface AttributeRequest extends Serenity.ListRequest {
        ProductTypeId?: number;
        ItemTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        MetalId?: number;
        KaratId?: number;
        MetalColorId?: number;
        ProductSizeId?: number;
        StoneSizeId?: number;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        ShapeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        QualityId?: number;
        StoneColorId?: number;
        Purity?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        StampId?: number;
        StoneStatusId?: number;
        SettingId?: number;
    }
}
